// extracted by mini-css-extract-plugin
module.exports = {"home_banner":"Home_home_banner__WBHqA","additional_coverages_custom":"Home_additional_coverages_custom__VMoGd"};